


















import { Component, Prop } from 'vue-property-decorator';
import DescriptionBar from './DescriptionBar.vue';
import ScoreInputBase from './ScoreInputBase';
import NumericButton from './NumericButton.vue';

@Component({ components: { DescriptionBar, NumericButton } })
export default class Buttons extends ScoreInputBase {
  @Prop({ default: 10 }) public max!: number;
  @Prop({ default: 0 }) public min!: number;
  @Prop({ default: () => [] }) public colors: string[];
  public getColor(score: number): string {
    return this.colors ? this.colors[score] : null;
  }
}
